import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4cb8441c")

_pushScopeId("data-v-4cb8441c")
const _hoisted_1 = { class: "fridgeeconavi-page" }
const _hoisted_2 = { class: "fridgeeconavi-page-topmessage" }
const _hoisted_3 = { class: "fridgeeconavi-page-topmessage-text" }
const _hoisted_4 = {
  key: 0,
  class: "fridgeeconavi-page-selectdatearea"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "fridgeeconavi-page-spacer" }, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "fridgeeconavi-page-grapharea"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsSelectDateBar = _resolveComponent("FridgeDetailsSelectDateBar")
  const _component_FridgeEconaviContentItem = _resolveComponent("FridgeEconaviContentItem")
  const _component_HorizontalPaging = _resolveComponent("HorizontalPaging")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.topMessage), 1)
    ]),
    (_ctx.dateList.length>0)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_FridgeDetailsSelectDateBar, {
            key: _ctx.selectIndex,
            dateList: _ctx.dateList,
            type: _ctx.dateType,
            selectIndex: _ctx.selectIndex,
            isDisableButtonHidden: _ctx.isDisableButtonHidden,
            onOnSelect: _ctx.selectedDateIndex
          }, null, 8, ["dateList", "type", "selectIndex", "isDisableButtonHidden", "onOnSelect"])
        ]))
      : _createCommentVNode("", true),
    _hoisted_5,
    (_ctx.graphInfoList.length>0)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode(_component_HorizontalPaging, {
            class: "fridgeeconavi-page-grapharea-content",
            currentPageIndex: _ctx.selectIndex,
            initialPageIndex: _ctx.initialPageIndex,
            onOnSelect: _ctx.selectPage
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.graphInfoList, (info) => {
                return (_openBlock(), _createBlock(_component_FridgeEconaviContentItem, {
                  class: "fridgeeconavi-page-grapharea-content-item",
                  key: info.date,
                  info: info
                }, null, 8, ["info"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1
          }, 8, ["currentPageIndex", "initialPageIndex", "onOnSelect"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"])
  ]))
})